// extracted by mini-css-extract-plugin
export var animationContainer = "_ih-0";
export var asteriskIcon = "_ih-8";
export var conversationLeftSection = "_ih-4";
export var conversationListItem = "_ih-3";
export var conversationMiddleSection = "_ih-5";
export var conversationRightSection = "_ih-6";
export var detailsContent = "_ih-1";
export var listContainer = "_ih-7";
export var modalContent = "_ih-2";